import axios from 'axios';
import { buildApiV2Url } from '../../../api/utils/apiUtils';
import { getUploadData } from '../../../api/utils/getUploadData';

export default (collectionPath, entityId, blob) =>
  axios.post(
    buildApiV2Url(`${collectionPath}/${entityId}/preview`),
    getUploadData(blob, entityId),
  );
